module.exports = __webpack_public_path__ + "img/logo-branco-sem-fundo.35d68dd5.png";